import {useQuery, type UseQueryOptions} from '@tanstack/react-query';
import {type QueryError} from '../../lib/queryClient';
import {
	getProgressReport,
	getProgressReportEndpoint,
	type GetProgressReportResult,
	type GetProgressReportRequestOptions,
} from '../getProgressReport';
export * from '../getProgressReport';

export type GetProgressReportQueryParams = GetProgressReportRequestOptions;
export type GetProgressReportQueryKey = [string, GetProgressReportQueryParams];

export type GetProgressReportQueryOptions = Omit<
	UseQueryOptions<
		GetProgressReportResult,
		QueryError,
		GetProgressReportResult,
		GetProgressReportQueryKey
	>,
	'queryKey' | 'queryFn'
>;

/**
 * react-query wrapper for `getProgressReport`
 * @param queryKeyParams
 * @param options
 */
export const useReactQueryGetProgressReport = (
	queryKeyParams?: GetProgressReportQueryParams,
	options?: GetProgressReportQueryOptions,
) =>
	useQuery<
		GetProgressReportResult,
		QueryError,
		GetProgressReportResult,
		GetProgressReportQueryKey
	>({
		queryKey: [getProgressReportEndpoint, queryKeyParams || {uuid: ''}],
		queryFn: ({queryKey, signal}) => getProgressReport(queryKey[1], signal),
		enabled: !!queryKeyParams?.uuid,
		...options,
	});

export default useReactQueryGetProgressReport;
